// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum FacilityCountingMode {
	Unknown = 0,
	Occupancy = 1,
	InOutDelta = 2,
	Hybrid = 3,
}

export const FacilityCountingModeDisplayNames: { [key in keyof typeof FacilityCountingMode]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Occupancy": "Spot Occupancy",
	1 : "Spot Occupancy",
	"InOutDelta": "In/Out Delta",
	2 : "In/Out Delta",
	"Hybrid": "Spots and In/Out",
	3 : "Spots and In/Out",
}

export const getFacilityCountingModeDisplayName = (key: FacilityCountingMode | (keyof typeof FacilityCountingMode & string)) => {
	return FacilityCountingModeDisplayNames[key];
}

